/**
 * MobileModeInfoTip — Wraps the Mobile Mode button to show a tooltip on hover.
 */

import { useState, useRef } from 'react';

const MOBILE_TOOLTIP = [
    'Mobile Mode simulates the alert experience of our mobile application.',
    'The ability to accept alerts is still based on System Settings.',
];

const MobileModeInfoTip = ({ children }) => {
    const [open, setOpen] = useState(false);
    const ref = useRef(null);
    const [style, setStyle] = useState({});

    const handleEnter = () => {
        if (!ref.current) return;
        const rect = ref.current.getBoundingClientRect();
        const spaceRight = window.innerWidth - rect.left;
        const spaceBelow = window.innerHeight - rect.bottom;

        setStyle({
            position: 'fixed',
            left: spaceRight < 320 ? undefined : `${rect.left}px`,
            right: spaceRight < 320 ? '16px' : undefined,
            top: spaceBelow < 80 ? undefined : `${rect.bottom + 6}px`,
            bottom: spaceBelow < 80 ? `${window.innerHeight - rect.top + 6}px` : undefined,
            maxWidth: '300px',
            whiteSpace: 'normal',
        });
        setOpen(true);
    };

    return (
        <span
            ref={ref}
            onMouseEnter={handleEnter}
            onMouseLeave={() => setOpen(false)}
            onMouseUp={() => setOpen(false)}
            style={{ position: 'relative' }}
        >
            {children}
            {open && (
                <span className="na-type-popover" style={style}>
                    <span style={{ fontSize: 'var(--font-size-xs)', color: 'var(--color-text-muted)', fontWeight: 'var(--font-weight-semibold)' }}>About Mobile Mode</span>
                    <span style={{ fontSize: 'var(--font-size-xs)', color: 'var(--color-text-body)', lineHeight: '1.45' }}>{MOBILE_TOOLTIP.join(' ')}</span>
                </span>
            )}
        </span>
    );
};

export default MobileModeInfoTip;
